import FormComponent from "../../../../../components/FormComponent";
import {css, html} from "@isceco/widget-library2/external/lit";
import '@isceco/widget-library2/basic-elements/Form/Form'
import {when} from "@isceco/widget-library2/external/lit/directives/when";
import '../../../../../components/InlineNotification'
import SasBeschwerdeformularService from "./SasBeschwerdeformularService";

export default class SasBeschwerdeformular extends FormComponent {

  get translationFile() {
    return './views/WBF/SECO/SAS/Beschwerdeformular/i18n.json'
  }

  constructor() {
    super();
    this.artDerBeschwerde = 'SAS'
    this.vorpruefung = true;
  }

  get css() {
    return css`
      .column {
        display: flex;
        flex-direction: column;
        gap: var(--isceco-space-200);
      }

      .two-col-layout {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: var(--isceco-space-200);
        justify-content: space-between;
      }

      .two-col-layout > * {
        flex: 1;
      }

      @media (min-width: 768px) {
        .two-col-layout {
          flex-direction: row;
        }
      }
    `
  }

  connectedCallback() {
    super.connectedCallback();
    this.render()
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form id="sas-beschwerdeformular"
                   include-disabled
                   submit-button-text="${this.i18n.translate(submitKey)}"
                   @submit="${e => this._submit(e)}"
                   .disabled="${!this.vorpruefung}">
        <div slot="buttons">
          <isceco-button text="${this.i18n.translate('form.button.abort')}"
                         @click="${() => this.abort()}"
                         variant="secondary"
                         .disabled="${!this.preview || !this.vorpruefung}"
          ></isceco-button>
        </div>
        <div slot="form-elements" class="form-elements">
          ${this._renderArtderBeschwerde()}
          ${when(
            this.artDerBeschwerde === 'SAS',
            () => this._renderBetroffeneStelle(),
            () => this._renderVorpruefung()
          )}
          ${when(!this.vorpruefung, () => this._renderNotice())}
          ${when(this.vorpruefung, () => html`
            ${this._renderKontaktangaben()}
            ${this._renderBeschwerde()}
            ${this._renderNachweise()}
            ${this._renderBestaetigung()}
          `)}
        </div>
      </isceco-form>
    `
  }

  _submit(event) {
    if (!this.preview) {
      this.preview = true
      this.render()
      return
    }

    new SasBeschwerdeformularService().submit(event.detail, event.target)
  }

  _renderArtderBeschwerde() {
    return html`
      <isceco-card text="${this.i18n.translate('card.art.der.beschwerde.title')}">
        <isceco-radio-group
          name="artderbeschwerde"
          label="${this.i18n.translate('card.art.der.beschwerde.radio.group.title')}"
          value="SAS"
          .items="${[
            {
              value: 'SAS',
              name: this.i18n.translate('card.art.der.beschwerde.radio.group.option.one')
            },
            {
              value: 'KBS',
              name: this.i18n.translate('card.art.der.beschwerde.radio.group.option.two')
            }
          ]}"
          @change="${e => this._setArtDerBeschwerde(e.detail.value)}"
          .readonly="${this.preview}"
          required
        ></isceco-radio-group>
      </isceco-card>
    `
  }

  _setArtDerBeschwerde(art) {
    this.artDerBeschwerde = art;
    this.vorpruefung = true;
    this.render()
  }

  _renderVorpruefung() {
    return html`
      <isceco-card text="${this.i18n.translate('card.vorpruefung.title')}">
        <div class="column">
          <isceco-radio-group
            name="vorpruefung"
            label="${this.i18n.translate('card.vorpruefung.radio.group.title')}"
            value="VON_SAS_AKKREDITIERT"
            .items="${[
              {
                value: 'VON_SAS_AKKREDITIERT',
                name: this.i18n.translate('card.vorpruefung.radio.group.option.one')
              },
              {
                value: 'NICHT_VON_SAS_AKKREDITIERT',
                name: this.i18n.translate('card.vorpruefung.radio.group.option.two')
              }
            ]}"
            @change="${e => this._setVorpruefung('VON_SAS_AKKREDITIERT' === e.detail.value)}"
            .readonly="${this.preview}"
            required
          ></isceco-radio-group>
          ${when(
            this.vorpruefung,
            () => html`
              <div class="two-col-layout">
                ${this._renderAkkreditierungstyp(true)}
                ${this._renderAkkreditierungsnummer(true)}
              </div>
            `
          )}
        </div>
      </isceco-card>
    `
  }

  _setVorpruefung(value) {
    this.vorpruefung = value;
    this.render()
  }

  _renderNotice() {
    return html`
      <inline-notification variant="warning">
        <div style="display: flex; flex-direction: column;">
          <h3>${this.i18n.translate('card.vorpruefung.hinweis.title')}</h3>
          <span
            style="margin-bottom: var(--isceco-space-200)">${this.i18n.translate('card.vorpruefung.hinweis.text')}</span>
        </div>
      </inline-notification>
    `
  }

  _renderAkkreditierungstyp(required) {
    const akkreditierungstypen = [
      "akkreditierungstyp.one",
      "akkreditierungstyp.two",
      "akkreditierungstyp.three",
      "akkreditierungstyp.four",
      "akkreditierungstyp.five",
      "akkreditierungstyp.six",
      "akkreditierungstyp.seven",
      "akkreditierungstyp.eight",
      "akkreditierungstyp.nine",
      "akkreditierungstyp.ten"
    ].map((it, index) => ({value: `AKKREDITIERUNGSTYP_${index}`, name: this.i18n.translate(it)}));
    return html`
      <isceco-dropdown
        label="${this.i18n.translate('akkreditierungstyp') + (required ? '*' : '')}"
        name="akkreditierungstyp"
        .required="${required}"
        .readonly="${this.preview}"
        .i18n="${this.i18n}"
        .items="${akkreditierungstypen}"
        @change="${() => null}">
      </isceco-dropdown>
    `
  }

  _renderAkkreditierungsnummer(required = false) {
    return html`
      <isceco-text-input
        label="${this.i18n.translate('akkreditierungsnummer') + (required ? '*' : '')}"
        name="akkreditierungsnummer"
        pattern="^[0-9]{4}$"
        pattern-error-text="${this.i18n.translate('akkreditierungsnummer.pattern.error.text')}"
        .required="${required}"
        .readonly="${this.preview}"
      ></isceco-text-input>
    `
  }

  _renderBetroffeneStelle() {
    return html`
      <isceco-card text="${this.i18n.translate('card.betroffene.stelle.title')}">
        <div class="column">
          <div class="two-col-layout">
            ${this._renderAkkreditierungstyp()}
            ${this._renderAkkreditierungsnummer()}
          </div>
          <isceco-text-input
            label="${this.i18n.translate('card.betroffene.stelle.name')}"
            name="betroffenestelle.name"
            required
            .readonly="${this.preview}"
          ></isceco-text-input>
          <isceco-radio-group
            name="betroffenestelle.bezug"
            label="${this.i18n.translate('card.betroffene.stelle.beschwerde.bezug')}"
            value="FACHLICH"
            .items="${[
              {
                value: 'FACHLICH',
                name: this.i18n.translate('card.betroffene.stelle.beschwerde.bezug.option.one')
              },
              {
                value: 'FINANZIELL',
                name: this.i18n.translate('card.betroffene.stelle.beschwerde.bezug.option.two')
              }
            ]}"
            @change="${this._onEingereichtVonChange}"
            .readonly="${this.preview}"
            required
          ></isceco-radio-group>
        </div>
      </isceco-card>
    `
  }

  _renderKontaktangaben() {
    return html`
      <isceco-card text="${this.i18n.translate('card.kontaktangaben.title')}">
        <div class="column">
          <div class="two-col-layout">
            <isceco-text-input
              name="kontaktangaben.vorname"
              label="${this.i18n.translate('card.kontaktangaben.vorname')}"
              .readonly="${this.preview}"
              required
            ></isceco-text-input>
            <isceco-text-input
              name="kontaktangaben.nachname"
              label="${this.i18n.translate('card.kontaktangaben.nachname')}"
              .readonly="${this.preview}"
              required
            ></isceco-text-input>
          </div>
          <isceco-text-input
            name="kontaktangaben.email"
            label="${this.i18n.translate('card.kontaktangaben.email')}"
            type="email"
            pattern-error-text="${this.i18n.translate('card.kontaktangaben.email.pattern.error')}"
            .readonly="${this.preview}"
            required
          ></isceco-text-input>
          <div class="two-col-layout">
            <isceco-text-input
              name="kontaktangaben.strasse"
              label="${this.i18n.translate('card.kontaktangaben.strasse')}"
              .readonly="${this.preview}"
            ></isceco-text-input>
            <isceco-text-input
              name="kontaktangaben.strassennummer"
              label="${this.i18n.translate('card.kontaktangaben.strasse.nummer')}"
              .readonly="${this.preview}"
            ></isceco-text-input>
          </div>
          <div class="two-col-layout">
            <isceco-text-input
              name="kontaktangaben.plz"
              label="${this.i18n.translate('card.kontaktangaben.plz')}"
              .readonly="${this.preview}"
            ></isceco-text-input>
            <isceco-text-input
              name="kontaktangaben.ort"
              label="${this.i18n.translate('card.kontaktangaben.ort')}"
              .readonly="${this.preview}"
            ></isceco-text-input>
          </div>
        </div>
      </isceco-card>
    `
  }

  _renderBeschwerde() {
    return html`
      <isceco-card text="${this.i18n.translate('card.beschwerde.title')}">
        <isceco-textarea label="${this.i18n.translate('card.beschwerde.beschrieb')}"
                         name="beschwerde.beschrieb"
                         rows="4"
                         .readonly="${this.preview}"
                         resize="manual"
                         required
        ></isceco-textarea>
      </isceco-card>
    `
  }

  _renderNachweise() {
    return html`
      <isceco-card text="${this.i18n.translate('card.nachweis.title')}">
        <isceco-file-input
          label="${this.i18n.translate('card.nachweis.file.upload')}"
          name="attachments"
          accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          maxfiles="25"
          maxsize="${this.fileMaxSize}"
          .fileInputService="${this.fileInputService}"
          .disabled="${this.preview}"
          multiple
          required
        ></isceco-file-input>
      </isceco-card>
    `
  }

  _renderBestaetigung() {
    return html`
      <isceco-card text="${this.i18n.translate('card.bestaetigung.title')}">
        <isceco-checkbox
          name="bestaetigung.korrekteAngaben"
          label="${this.i18n.translate('card.bestaetigung.option.one')}"
          .readonly="${this.preview}"
          required
        ></isceco-checkbox>

        <div style="display:flex; align-items: center; gap: var(--isceco-space-100)">
          <isceco-checkbox
            name="bestaetigung.datenschutzbestimmung"
            label="${this.i18n.translate('card.bestaetigung.option.two')}"
            .readonly="${this.preview}"
            required
          ></isceco-checkbox>
          (<a href="${this.i18n.translate('card.bestaetigung.option.two.link.url')}" target="_blank">
          ${this.i18n.translate('card.bestaetigung.option.two.link')}
        </a>).
        </div>

        <isceco-checkbox
          name="bestaetigung.keineBekanntgabe"
          label="${this.i18n.translate('card.bestaetigung.option.three')}"
          .readonly="${this.preview}"
          required
        ></isceco-checkbox>
      </isceco-card>
    `
  }

}

customElements.define('eform-seco-sas-beschwerdeformular', SasBeschwerdeformular);
